export const SELECT_RISK_LEVEL = 'SELECT_RISK_LEVEL'

export const RESET_RISK_EVALUATED = 'RESET_RISK_EVALUATED'

export const selectRiskLevel = (riskLevel) => ({
  type: SELECT_RISK_LEVEL,
  payload: riskLevel,
})

export const SELECT_QUESTIONNAIRE = 'SELECT_QUESTIONNAIRE'

export const selectQuestionnaire = (questionnaires) => ({
  type: SELECT_QUESTIONNAIRE,
  payload: questionnaires,
})

export const UPDATE_QUESTIONNAIRE = 'UPDATE_QUESTIONNAIRE'

export const updateQuestionnaire = (questionnaire) => ({
  type: UPDATE_QUESTIONNAIRE,
  payload: questionnaire,
})

export const RESET_ANSWERED_QUESTION = 'RESET_ANSWERED_QUESTION'

export const resetAnsweredQuestion = () => ({
  type: 'RESET_ANSWERED_QUESTION',
})

export const ANSWER_QUESTION = 'ANSWER_QUESTION'

export const answerQuestion = (index, value) => ({
  type: ANSWER_QUESTION,
  payload: { index, value },
})

export const CALCULATE_RISK = 'CALCULATE_RISK'

export const calculateRisk = (riskState) => ({
  type: CALCULATE_RISK,
  payload: riskState,
})

export const resetRiskEvaluated = () => ({
  type: RESET_RISK_EVALUATED,
})

export const ACCEPT_HIGHER_RISK_INVESTMENT = 'ACCEPT_HIGHER_RISK_INVESTMENT'

export const acceptHigherRiskInvestment = () => ({
  type: ACCEPT_HIGHER_RISK_INVESTMENT,
})

export const ACCEPT_FOREIGN_INVESTMENT = 'ACCEPT_FOREIGN_INVESTMENT'

export const acceptForeignInvestment = () => ({
  type: ACCEPT_FOREIGN_INVESTMENT,
})

export const SET_AGENT_COMMENT = 'SET_AGENT_COMMENT'

export const setAgentComment = (comment) => ({
  type: SET_AGENT_COMMENT,
  payload: comment,
})
